const LoadingState = ({ message = "Loading..." }) => {
  return (
    <div className="flex items-center justify-center h-96" data-testid="loading-state">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-4">
          <div className="absolute inset-0 border-4 border-gray-800 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-t-[#3dd9c5] rounded-full animate-spin"></div>
        </div>
        <p className="text-gray-400 text-sm">{message}</p>
      </div>
    </div>
  );
};

export default LoadingState;
